module.exports = __webpack_public_path__ + "img/index11.37c721c6.png";